import { FlexProps } from '@chakra-ui/react';
import { IStorage } from '@monetize/types/app';
import { truncateFileName } from '@monetize/utils/core';
import React, { useEffect, useState } from 'react';
import { MFlex, MLink, MSkeleton, MText } from '..';
import { base64ToArrayBuffer } from '../../../utils';
import { downloadBlobAsFile } from '../../../utils/download';
import { PreviewPdf } from './PreviewPdf';

interface PreviewStorageFileProps extends FlexProps {
  file: IStorage;
  getDocument?: (file: IStorage) => Promise<ArrayBuffer | null>;
}

export const PreviewStorageFile: React.FC<PreviewStorageFileProps> = ({
  file,
  getDocument,
  ...rest
}) => {
  const [document, setDocument] = useState<ArrayBuffer | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (file.contentBase64Encoded) {
      setDocument(base64ToArrayBuffer(file.contentBase64Encoded));
    } else if (getDocument && !document) {
      setIsLoading(true);
      getDocument(file)
        .then((buffer) => {
          buffer && setDocument(buffer);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [file, getDocument]);

  const downloadFile = async () => {
    downloadBlobAsFile(document, file.filename);
  };

  if (isLoading) {
    return <MSkeleton height="100px" />;
  }
  if (file.mediaType === 'application/pdf' && document) {
    return (
      <MFlex flex={1} {...rest}>
        <PreviewPdf
          currentPdfFile={document}
          filename={file.filename}
          showDownloadButton={true}
        />
      </MFlex>
    );
  }

  return (
    <MFlex {...rest}>
      <MLink
        textDecor="underline"
        fontSize="sm"
        onClick={downloadFile}
        maxW="100px"
      >
        {truncateFileName(file.filename, 50)}
      </MLink>{' '}
      <MText fontStyle="italic">Preview not available for this file type</MText>
    </MFlex>
  );
};
